import { render, staticRenderFns } from "./PhoneSettings.vue?vue&type=template&id=3adba97c&scoped=true&"
import script from "./PhoneSettings.vue?vue&type=script&lang=js&"
export * from "./PhoneSettings.vue?vue&type=script&lang=js&"
import style0 from "./PhoneSettings.vue?vue&type=style&index=0&id=3adba97c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adba97c",
  null
  
)

export default component.exports